import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Head from '../constants/Head'
import { t } from 'i18next'
import { useDispatch } from 'react-redux'
import { API_BASE_IMAGE_URL } from '../constants/configuration'
import { getPrivacy } from '../redux/actionCreator'

export default function Privacy() {
    const dispatch = useDispatch()
    const [language, setLanguage] = useState('')
    const [privacy, setPrivacy] = useState({})
    const [filePath, setPath] = useState('')

    useEffect(() => {
        const lang = localStorage.getItem('lang')
        setLanguage(lang)
    }, [localStorage.getItem('lang')])

    useEffect(() => {
        dispatch(getPrivacy((res) => {
            setPrivacy(res.data.data)
            setPath(res.data.image_path)
        }))
    }, [])

    return (
        console.log(privacy, 'privacy'),
        <>
            <Head title={t('html_title.about')} metatitle={t('html_title.about')} metaDescription={t('html_title.about')} />
            <Header />

            <section className="innerpage__header">
                <div className="container sm-pad-0">
                    <div className="banner__image">
                    <img src={API_BASE_IMAGE_URL + filePath + '/' + privacy?.image_name} className='w-100' alt="" />

                        <div className="contents">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="header__title">
                                        <h2>{language == 'en' ? privacy?.title : privacy?.title_ar}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="privacy__policy">
                <div className="container">
                    {/* <h1>{language == 'en' ? privacy?.title : privacy?.title_ar}</h1> */}
                    <p dangerouslySetInnerHTML={{ __html: language == 'en' ? privacy?.description : privacy?.description_ar }}></p>
                </div>
            </section>
            <Footer />
        </>
    )
}
